export enum FBPolicyEnforcementModalType {
  WARNING = 'warning',
  BLOCK = 'block',
  WAS_BLOCK = 'was_block',
}
